import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { ToolbarItem } from '@kinesis/bungle';
import { DownloadButton } from '@/components/download-button';
import { useExportDisclosureMutation } from '@/api/disclosures';

// Per-route toolbar for an open disclosure (the detail view). Mirrors suit's
// `toolbar-disclosure`: a single "Export as ZIP" button that fires the
// export. The signed download URL is followed inside the mutation
// (`onQueryStarted`), so this just triggers it and spins on the mutation's
// own in-flight flag while the archive is prepared. The inventory-level
// "New disclosure" lives on the *list* toolbar (`toolbar-disclosures`).
const ToolbarDisclosure = () => {
  const params = useParams<{ disclosureId: string }>();
  const disclosureId = Number(params.disclosureId);
  const [exportDisclosure, { isLoading: isExporting }] =
    useExportDisclosureMutation();

  const onExport = useCallback(() => {
    exportDisclosure({ id: disclosureId });
  }, [disclosureId, exportDisclosure]);

  return (
    <ToolbarItem>
      <DownloadButton downloading={isExporting} onClick={onExport}>
        Export as ZIP
      </DownloadButton>
    </ToolbarItem>
  );
};

export { ToolbarDisclosure };
